export const INITIAL_THEMES = [];

export const SET_THEMES = 'SignUpSheet/*/SET_THEMES';
